export default __webpack_public_path__ + "static/media/special-application-banner.4def55e5.jpg";